import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VeeValidate from 'vee-validate'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

Vue.use(VueScrollTo)

Vue.use(VeeValidate, {
  events: 'change'
});

VeeValidate.Validator.extend('postcode', {
  validate: function (value) {
    return /^[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}$/i.test(value)
  },
  getMessage: function () {
    return 'This field format is invalid'
  },
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')